import type { ShopperProducts } from '@/scapi';

type CategoryPathNode = {
    id?: string;
    name?: string;
    c_url?: unknown;
};

function categoryNodeMatchesPlpPathname(node: CategoryPathNode, targetPathname: string): boolean {
    const nodeUrl = node.c_url;
    return typeof nodeUrl === 'string' && nodeUrl.length > 0 && nodeUrl === targetPathname;
}

export type PlpPathnameCategoryMatchSource = 'route' | 'directChild' | 'ancestor';

export type ResolvedPlpPathnameCategory = {
    node: ShopperProducts.schemas['Category'];
    source: PlpPathnameCategoryMatchSource;
};

/**
 * Resolves a category node already present on the current PLP tree (route, direct child, or
 * `parentCategoryTree`) for optimistic PLP header/breadcrumb while navigating to another `/c/...` URL.
 */
export function resolveCategoryNodeForPlpPathname(
    category: ShopperProducts.schemas['Category'],
    targetPathname: string
): ResolvedPlpPathnameCategory | undefined {
    if (categoryNodeMatchesPlpPathname(category, targetPathname)) {
        return { node: category, source: 'route' };
    }

    const directChild = category.categories?.find((child) => categoryNodeMatchesPlpPathname(child, targetPathname));
    if (directChild) {
        return { node: directChild, source: 'directChild' };
    }

    const ancestor = category.parentCategoryTree?.find((node) => categoryNodeMatchesPlpPathname(node, targetPathname));
    if (ancestor) {
        return { node: ancestor as ShopperProducts.schemas['Category'], source: 'ancestor' };
    }

    return undefined;
}
